import React, { useState, useEffect, useContext } from 'react';
import { addToBasket } from '../../services/BasketService';
import { getAllProducts } from '../../services/ProductService';
import { getAllCategories } from '../../services/CategoryService'; 
import { addToFavorite, removeFromFavorite } from '../../services/FavoriService';
import { Context } from '../../ContextApi/ContextApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import style from './index.module.css';

export default function Shop() {
  const [prod, setProd] = useState([]);
  const [categories, setCategories] = useState([]); 
  const [searchTerm, setSearchTerm] = useState(""); 
  const [selectedPriceRange, setSelectedPriceRange] = useState(""); 
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 

  const getall = async (page) => {
    let res = await getAllProducts(page - 1, itemsPerPage);
    
    if (selectedCategoryId) {
      res = res.filter(product => product.productCategoryId === Number(selectedCategoryId));
    }
    
    if (selectedPriceRange) {
      const [minPrice, maxPrice] = selectedPriceRange.split(" - ").map(Number);
      res = res.filter(product => product.productPrice >= minPrice && product.productPrice <= maxPrice);
    }
    
    if (searchTerm) {
      res = res.filter(product => product.productName.toLowerCase().includes(searchTerm.toLowerCase()));
    }
    
    setProd(res);
  };

  const getCategories = async () => {
    const res = await getAllCategories();
    setCategories(res);
  };

  useEffect(() => {
    getall(currentPage);
    getCategories(); 
  }, [currentPage, selectedPriceRange, selectedCategoryId, searchTerm]);

  return (
    <div>
      <div className={style.shop}>
        <div className={style.our}>
          <p>
            <a href="/Home">Home</a>/<span>Shop</span>
          </p>
          <h1>Explore All Products</h1>
        </div>
        <div className={style.img1}>
          <img src="https://new.axilthemes.com/demo/template/etrade/assets/images/product/product-45.png" alt="Banner" />
        </div>
      </div>

      <div className={style.search}>
        <div className={style.inp}>
          <input
            placeholder="What are you looking for"
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} 
          />
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
        <div className={style.select}>
          <select onChange={(e) => setSelectedCategoryId(e.target.value)}>
            <option value="">Categories</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
          <select onChange={(e) => setSelectedPriceRange(e.target.value)}>
            <option value="">Price Range</option>
            <option value="0 - 100">0 - 100</option>
            <option value="100 - 500">100 - 500</option>
            <option value="500 - 1000">500 - 1000</option>
          </select>
        </div>
      </div>

      <div className={style.product}>
        {prod.length > 0 ? (
          prod.map((x, i) => <ProductCard key={i} product={x} />)
        ) : (
          <p>No products found.</p>
        )}
      </div>
        <div className={style.pag}>
          <button className="page-link" 
            onClick={() => setCurrentPage(currentPage - 1)} 
            disabled={currentPage === 1} style={{color:currentPage === 1 ? 'gray' : ''}}>Previous</button>
          <span>  {currentPage} </span>
          <button 
            className="page-link" 
            onClick={() => setCurrentPage(currentPage + 1)} 
            disabled={prod.length < itemsPerPage} 
            style={{ color: prod.length < itemsPerPage ? 'gray' : '' }}>Next
          </button>
         </div>
    </div>
  );
}

const ProductCard = ({ product }) => {
  const [isFavorite, setIsFavorite] = useState(product?.productIsFavorite);
  const { user } = useContext(Context);
  const redirect = useNavigate();

  const handleFavoriteClick = async (id) => {
    if (user?.loggedIn) {
      try {
        if (isFavorite) {
          await removeFromFavorite(id, user?.userId);
          setIsFavorite(false);
          toast.info("Removed from favorites!");
        } else {
          await addToFavorite(id, user?.userId);
          setIsFavorite(true);
          toast.success("Added to favorites!");
        }
      } catch (error) {
        toast.error("Something went wrong!");
      }
    } else {
      toast.warn("Please log in to add favorites!");
      redirect("/login");
    }
  };

  const handleReadMoreClick = () => {
    redirect(`/product/${product.productId}`);
  };

  const handleAddToBasket = async (id) => {
    try {
      await addToBasket(id, 1);
      toast.success("Product added to basket!");
    } catch (error) {
      toast.error("Failed to add product to basket!");
    }
  };

  return (
    <div className={style.card2}>
      <div className={style.img}>
        <img src={product.photos?.[0]?.photoName} alt={product.productName} />
        <div className={style.read}>
          <span onClick={handleReadMoreClick} className={style.fa}>
            <i className="fa-brands fa-readme"></i>
          </span>
          <span onClick={() => handleAddToBasket(product.productId)} className={style.add}>
            Add to cart
          </span>
          <span onClick={() => handleFavoriteClick(product.productId)} className={style.fa}>
            <i className="fa-regular fa-heart" style={{ color: isFavorite ? "red" : "gray" }}></i>
          </span>
        </div>
      </div>
      <div className={style.text2}>
        <h4>{product.productName}</h4>
        <p>$ {product.productPrice}</p>
      </div>
    </div>
  );
};
